module.exports = __webpack_public_path__ + "img/MarionChopard.ba3ca03c.jpeg";